export enum Page {
  home = "home",
  fearCity = "fearCity",
  storyA = "storyA",
  storyB = "storyB",
  storyC = "storyC",
  storyE = "storyE",
  ending = "ending",
  submitFear = "submitFear",
  rabbitCity = "rabbitCity"
}



// WEBPACK FOOTER //
// ./src/page/constants/Page.ts